import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { patientEncounterClassificationList } from "../../../../../../../services/patientEncounterClassification.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const PatientCareClassificationExternalIdThen = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(patientEncounterClassificationList);

  const [options, setOptions] = useState<ISelectType[]>([]);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest({});
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: String(item.identifier),
          name: item.description ?? "",
        })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        options={options}
        name="patientCareClassificationExternalIdThen"
        size="small"
        fullWidth
        getOptionLabel={({ name }) => name}
        label={t(
          translationPath + "patient_care_classification_external_id_then",
        )}
      />
    </Grid>
  );
});
